module.exports = __webpack_public_path__ + "static/fever-poster-ff16d6fcb34399a38a3e1d867b9f8658.jpg";